import type { paths } from "@securityjourney/svc-idp/dist/gen/idp";

import { OpenApiFetchWrapper } from "../openApiFetchWrapper";

export class IdpClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  // Sign out and clear authentication cookies
  async signOut() {
    return await this.post("/svc/idp/auth/signout", { credentials: "include" });
  }
}
